/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Fix_GitignoreInputs */

const en_rd_fix_gitignore = /** @type {(inputs: Rd_Fix_GitignoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignore node_modules, .env* and your build output so an agent never commits them.`)
};

const id_rd_fix_gitignore = /** @type {(inputs: Rd_Fix_GitignoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abaikan node_modules, .env*, dan folder hasil build supaya tidak pernah ikut ter-commit agent.`)
};

/**
* | output |
* | --- |
* | "Ignore node_modules, .env* and your build output so an agent never commits them." |
*
* @param {Rd_Fix_GitignoreInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_fix_gitignore = /** @type {((inputs?: Rd_Fix_GitignoreInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Fix_GitignoreInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_fix_gitignore(inputs)
	return en_rd_fix_gitignore(inputs)
});